import axios from 'axios';
import { AxiosPostType } from '../../../context/FetchProvider';
import { ResponseDueRow } from '../../../types/quiz';

export type ScheduleOptions = {
  flagged?: boolean;
};

/**
 * Get quiz item metdata.
 */
export const get = async (nodeID: number) =>
  (await axios.get<ResponseDueRow>(`/api/spaced-repetition/${nodeID}`)).data;

/**
 * Reschedule a quiz item's spaced repetition value.
 */
export const reschedule = async (nodeID: number, minutes: number) =>
  axios.put(`/api/spaced-repetition/${nodeID}/schedule`, {
    minutes,
  });

/**
 * Remove an item from the spaced repetition queue.
 */
export const unschedule = async (nodeID: number) =>
  axios.put(`/api/spaced-repetition/${nodeID}/unschedule`);

/**
 * Add an item to the spaced repetition queue.
 */
export const schedule = (
  post: AxiosPostType,
  nodeIDs: number[],
  options?: ScheduleOptions,
) =>
  post('/scheduleForReview', {
    nodeIDs,
    local: 0,
    ...(options?.flagged ? { unflag: 'unflag' } : {}),
  });

/**
 * Set the flagged value for a quiz item.
 */
export const setFlagged = (
  post: AxiosPostType,
  nodeIDs: number[],
  flagged: boolean,
) => schedule(post, nodeIDs, { flagged });
